import AddOnPurchasePriceWidget from "../activity/add-on-purchase/AddOnPurchasePriceWidget";
import { Checkbox, Tooltip, message } from "antd";
import React, { useContext } from "react";
import Counter from "../activity/Counter";
import defaultProductPic from "../../images/default-brand.jpg";
import PriceWidget from "../activity/PriceWidget";
import axios from "axios";
import { cartItemQtyUpdateUrl } from "../../utils/constant";
import { AppContext } from "../../store";
import { ICartItem } from "./ProductGroup";
import SCIcon from "../common/SCIcon";
import { getAuthToken } from "Utils/common";
import { gotoPdp } from "Utils/activityHelper";
import { cartTrackingDataPush } from "Utils/analyticsUtils";
export interface CartItemProps {
  cartItem: ICartItem;
  loginState: Object;
}

const CartItem: React.FC<CartItemProps> = (props: any) => {
  const { cartItem, setLoadingCart, loginState } = props;
  const { product } = cartItem;
  const { checkedCartItems, setCheckedCartItems, refreshCartData } =
    useContext(AppContext);
  const [resetCount, setResetCount] = React.useState(0);

  const quantityUpdating = React.useRef(false);
  const handleCartItemQtyChange = (newQty: number) => {
    if (product.purchaseType && quantityUpdating.current) return;
    quantityUpdating.current = true;
    const boundedQuantity = product.purchaseType && product.limitQty != null
      ? Math.min(newQty, product.limitQty) : newQty;
    console.log("newQty", newQty);
    setLoadingCart(true);
    axios(cartItemQtyUpdateUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: getAuthToken(),
      },
      data: {
        id: cartItem.id,
        quantity: boundedQuantity,
        activityId: cartItem.activityId
      },
    }).then((res) => {
      const respData = res.data;
      if (respData.status === "success") {
        console.log("cart item qty updated");
        refreshCartData();
        const dispatchObj = {
          method: 'quantity update',
          placement: 'cart',
          products: [{
            name: product.productName,
            catalogId: product.sku,
            variant: product.productSize,
            quantity: boundedQuantity,
            price: product.finalPrice ? Number(product.finalPrice) * boundedQuantity : '0'
          }]
        };
        cartTrackingDataPush({
          cartId: cartItem.activityId,
          actionType: 'add',
          dispatchObj
        });
        return;
      }
      if (respData.status === "inventory_not_enough") {
        message.warning(React.createElement("div", {
          style: {
            whiteSpace: 'pre-line'
          }
        }, respData.message));
        refreshCartData();
        setResetCount((pre) => pre + 1);
        return;
      }
      message.error('更新失败');
      setResetCount((pre) => pre + 1);
      refreshCartData();
    }).catch(() => {
      message.error('更新失败');
      setResetCount((pre) => pre + 1);
      refreshCartData();
    }).finally(() => { quantityUpdating.current = false; });
  };
  return (
    <div className="cartItemWrapper">
      <div className="checkboxWrapper">
        <Checkbox
          checked={checkedCartItems.has(cartItem.id)}
          onChange={(e) => {
            console.log("checkbox changed", cartItem.id);
            const checked = e.target.checked;
            if (checked) {
              checkedCartItems.add(cartItem.id);
              setCheckedCartItems(new Set(checkedCartItems));
            } else {
              checkedCartItems.delete(cartItem.id);
              setCheckedCartItems(new Set(checkedCartItems));
            }
            refreshCartData()
          }}
        ></Checkbox>
      </div>
      <div className="imgWrapper">
        <div className="productImg">
          <img
            alt=""
            src={product.productPic || defaultProductPic}
            onClick={() => {
              gotoPdp(product, loginState, "Shopping_Cart");
            }}
          ></img>
        </div>
        <div className="shipIconWrapper">{product.deliveryChannel === "SC" && <SCIcon />}</div>
      </div>
      <div className="descWrapper">
        <Tooltip title={<span dangerouslySetInnerHTML={{
          __html: product.productName
        }}></span>} trigger={"hover"}>
          <div
            className={product.pdpViewable ? "line1 linkable" : "line1"}
            onClick={() => {
              console.log("product card clicked");
              gotoPdp(product, loginState, "Shopping_Cart")
            }}
            dangerouslySetInnerHTML={{ __html: product.productName }}
          ></div>
        </Tooltip>
        <div className="line">
          <label>货号:</label>
          <span>{product.sku}</span>
        </div>
        <div className="line">
          <label>规格:</label>
          <span>{product.productSize}</span>
        </div>
      </div>
      <div className="sideWrapper">
        <Counter
          product={product}
          login={true}
          value={cartItem.quantity}
          onChange={handleCartItemQtyChange}
          resetCount={resetCount}
          maxQuantity={product.purchaseType ? (product.limitQty ?? undefined) : undefined}
        ></Counter>
        {product.purchaseType ? (
          <AddOnPurchasePriceWidget product={product} loginState={loginState} placeholder="cartItem" />
        ) : (
        <PriceWidget
          placeholder="cartItem"
          product={product}
          loginState={loginState}
          size="small"></PriceWidget>
        )}
      </div>
    </div>
  );
};

export default CartItem;
